<template>
  <li 
    :id="slug"
    class="collaborator" 
    :class="{ 
      hidden: hidden,
      faded: faded,
      selected: selected,
      fadein: fadein
    }"
  >
    <a 
      class="name"
      :class="{ 
        hovered: hovered,
      }"
      @mouseover="hoverinCollaborator"
      @mouseleave="hoveroutCollaborator"
      @click="clickCollaborator"
    >
      <span class="bullet" v-if="selected">✕</span>
      <span class   ="bullet" v-else>⤷</span>
      <span class="value"> {{ name }} </span>
    </a>
    <div 
      class="body"
      v-if="selected"
    >
      <vue-markdown 
        class="summary"
        v-if="summary"
        :source="summary"
      />
      <p class="date"> 
        last updated {{ moment( date ).format('MMM Do, YYYY') }} 
      </p>
    </div>
  </li>
</template>

<script>
import moment from 'moment'

export default {
  components: {  },
  name: "Collaborator",
  props: [
    'slug',
    'name',
    'summary',
    'date',
    'relationship',
    'projects'
  ],
  data() {
    return {
      hidden: false,
      hovered: false,
      faded: false,
      selected: false,
      fadein: false,
      relatedProjects: [],
      moment: moment,
    }
  },
  created() {
  },
  mounted() {
    const allProjects = this.$parent.$refs.projects
    this.projects.forEach((project) => {
      const relatedProject = allProjects.find(p => p.slug === project.slug)
      this.relatedProjects.push(relatedProject)
    })
    this.relatedProjects = this.reorderProjects(this.relatedProjects)
  },
  methods: { 
    hoverinCollaborator () { this.$emit('collaboratorHovered', this) },
    hoveroutCollaborator () { this.$emit('collaboratorUnhovered', this) },
    clickCollaborator () { this.$emit('collaboratorClicked', this) },
    reorderProjects(projects) {
      let ongoingProjects = projects.filter(project => !project.EndDate)
      ongoingProjects.sort((a,b) => new Date(b.StartDate) - new Date( a.StartDate))
      let pastProjects = projects.filter(project => project.EndDate)
      let orderedPastProjects = pastProjects.sort((a, b) => (new Date(b.EndDate) - new Date(a.EndDate)))
      return projects = ongoingProjects.concat(orderedPastProjects)
    }
  },
}
</script>

<style scoped>
.collaborator {
  /* transition: max-height 0.2s ease; */
}
.collaborator .body {
  max-height: 1500px;
  /* transition: max-height 0.5s ease; */
}
.collaborator.selected {
  border-bottom: var(--thin-grey);
}
.collaborator.selected .body {
  /* transition: opacity 0.2s ease, max-height 0.5s ease; */
}
.collaborator.selected a.name {
  border-bottom: none;
}
.collaborator.selected.fadein {
  max-height: 1500px;
  /* transition: max-height 0.5s ease; */
}
.collaborator.selected.fadein .body {
  padding-top: 0px;
  max-height: 1000px;
  /* transition: opacity 0.2s ease, max-height 0.4s ease; */
}
.collaborator .body p.date {
  opacity: 0.4;
  font-size: 9pt;
  font-style: italic;
}
</style>